module.exports = __webpack_public_path__ + "img/SoftwareCopyright_10.a0f63af6.png";